import { render, staticRenderFns } from "./ConsentSpotify.vue?vue&type=template&id=60812d7c&"
import script from "./ConsentSpotify.vue?vue&type=script&lang=js&"
export * from "./ConsentSpotify.vue?vue&type=script&lang=js&"
import style0 from "./ConsentSpotify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports